// 维修
export const repairListUrl = '/traffic/repair/list'
export const repairAddUrl = '/traffic/repair'
export const repairEditUrl = '/traffic/repair/{0}'
export const repairDeleteUrl = '/traffic/repair/{0}'
export const repairExportUrl = '/traffic/repair/export'
export const repairItemListUrl = '/traffic/repair/item/list'
export const carListUrl = '/car/list'

export const STATUSNUMBER = 1

// 保养
export const maintainListUrl = '/traffic/maintain/list'
export const maintainAddUrl = '/traffic/maintain'
export const maintainEditUrl = '/traffic/maintain/{0}'
export const maintainDeleteUrl = '/traffic/maintain/{0}'
export const maintainExportUrl = '/traffic/maintain/export'
export const maintainItemListUrl = '/traffic/maintain/item/list'